<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="search">
        <!-- @focus="focusSearch" -->
        <el-input
          v-model="search"
          placeholder="输入关键词..."
          @input="searchList"
          clearable
        ></el-input>
        <img src="@/assets/logistics/search.png" alt="" />
        <img
          v-if="redirect && backendFlag"
          @click="toBackend"
          src="@/assets/logistics/backend.png"
          alt=""
        />
        <img class="my_img" :src="$store.state.userInfo.icon" alt="" />
      </div>
      <div class="bar">
        <img
          src="@/assets/logistics/umbrella.png"
          alt=""
          @click="toUrl('/logistics/borrowingAnUmbrella')"
        />
        <!-- <img src="@/assets/logistics/hotel.png" alt="" @click="toUrl('')" /> -->
        <img
          src="@/assets/logistics/photoCasually.png"
          alt=""
          @click="toCasually('/photoCasually')"
        />
        <img
          src="@/assets/logistics/activityRoom.png"
          alt=""
          @click="toActivityRoom"
        />
        <img
          src="@/assets/logistics/canteen.png"
          alt=""
          @click="gotoCanteen"
        />
      </div>
      <!-- <div class="kong_con" style="text-align: center;font-size: 16px;margin-top: 30%;">暂无数据</div> -->
      <div class="tab">
        <van-dropdown-menu>
          <van-dropdown-item
            v-for="(item, index) in dropdownItems"
            :key="index"
            :options="item.options"
            v-model="item.value"
            :title="item.title"
            @open="clickDrop(index)"
            @change="changeDrop(item, $event)"
            :title-class="tabIndex === index ? 'active' : ''"
          />
        </van-dropdown-menu>
      </div>
      <div class="tag">
        <el-tag v-for="tag in tagList" :key="tag.text" closable :type="tag.text" @close="handleClose(tag)">
          {{ tag.text }}
        </el-tag>
      </div>
      <div class="list">
        <van-list
          v-loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <div
            class="list_item"
            v-for="(item, index) in list"
            :key="index"
            @click="toLogistics(item)"
          >
            <div class="left">
              <img :src="url + item.image" alt="" />
            </div>
            <div class="right">
              <div class="title" v-html="item.highlightedTitle"></div>
              <div class="rightBot">
                <div class="type">{{ item.name }}</div>
                <div class="time">{{ item.timeAgo }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/logistics";
import { redirectRoute } from "@/utils/tools";
import { getToken } from "@/utils/cookie";
export default {
  components: {},
  data() {
    return {
      search: "",
      dropdownItems: [], // 用于存储模拟的下拉项数据
      tabIndex: 0,
      menuId: 0,
      list: [],
      url: "https://hydt.nvc-lighting.com.cn/",
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      redirect: false,
      backendFlag: false,
      searchTimer: null, // 存储定时器
      highlightColor: "#f00", // 高亮颜色（红色）
      tagList: [],
    };
  },
  mounted() {
    // this.getMenuList();
    // this.fetchDropdownItems();
    this.getRedirect();
    let token = getToken();
    if (token) {
      if (
        token == "10005038" ||
        token == "10007372" ||
        token == "10008797" ||
        token == "10008704" ||
        token == "10008520" ||
        token == "10003948" ||
        token == "10004736" ||
        token == "10004865" ||
        token == "10005818"
      ) {
        this.backendFlag = true;
      }
    } else {
      this.$bus.$on("processToken", (res) => {
        if (
          res == "10005038" ||
          res == "10007372" ||
          res == "10008797" ||
          res == "10008704" ||
          res == "10008520" ||
          res == "10003948" ||
          res == "10004736" ||
          res == "10004865" ||
          res == "10005818"
        ) {
          this.backendFlag = true;
        }
      });
    }
    this.getMenuList();
  },
  methods: {
    // 搜索
    searchList() {
      clearTimeout(this.searchTimer); // 清除之前的定时器，防止多次执行
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList();
      }, 1000); // 设置延迟 500ms，可根据需求调整
    },
    // pc还是移动
    getRedirect() {
      this.redirect = redirectRoute();
    },
    onLoad() {
      if (this.loading) return;
      this.loading = true;
      setTimeout(() => {
        this.getList();
      }, 300); // 延迟 300ms 触发，减少频繁触发
    },
    //获取下拉菜单数据
    getMenuList() {
      api.queryList().then((res) => {
        if (res.code == 200) {
          const list = res.data;
          let mockData = [];
          list.forEach((item) => {
            if (item.parentId == 0 && item.hiddenStatus != 1) {
              mockData.push({
                value: item.menuId,
                title: item.name,
                options: [],
                show: item.hiddenStatus,
              });
            }
          });

          list.forEach((item) => {
            mockData.forEach((item1) => {
              if (item.parentId == item1.value && item.hiddenStatus != 1) {
                item1.options.push({
                  text: item.name,
                  value: item.menuId,
                });
              }
            });
          });

          // 根据 options 的长度过滤 mockData
          const filteredMockData = mockData.filter(
            (item) => item.options.length > 0 && item.show != 1
          );
          this.dropdownItems = filteredMockData;
          this.getList();
        }
      });
    },
    //获取列表数据
    getList() {
      this.loading = true;
      api
        .queryArticleList({
          keyWord: this.search,
          menuId: this.menuId
            ? this.menuId
            : this.dropdownItems.length > 0
            ? this.dropdownItems[0]?.value
            : 999,
          page: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code == 200) {
            this.total = res.data.total;
            this.finished = false;
            let newList = res.data.list;

            if (this.page == 1) {
              this.list = newList;
            } else {
              this.list = this.list.concat(newList);
            }

            if (this.list.length < this.total) {
              this.page = this.page + 1;
            } else {
              this.finished = true;
            }
            this.loading = false;

            // **高亮处理**
            this.list = this.list.map((item) => {
              if (!this.search) {
                return { ...item, highlightedTitle: item.title };
              }

              const keyword = this.search.replace(
                /[.*+?^${}()|[\]\\]/g,
                "\\$&"
              );
              const regex = new RegExp(`(${keyword})`, "gi");

              return {
                ...item,
                highlightedTitle: item.title.replace(
                  regex,
                  `<span style="color: ${this.highlightColor}; font-weight: bold;">$1</span>`
                ),
              };
            });
          }
        });
    },
    gotoCanteen(){
      window.open('https://doc.weixin.qq.com/forms/AAAAPwdrAAcAcsAsgatAFECNsKDh2m46f?page=1')
    },
    //跳转搜索
    focusSearch() {
      this.$router.push("/logistics/logisticsSearch");
    },
    //跳转
    toCasually(item) {
      this.$router.push(item);
      // let token = getToken();
      // if (
      //   token == "10005038" ||
      //   token == "10007372" ||
      //   token == "10008797" ||
      //   token == "10008704" ||
      //   token == "10007380" ||
      //   token == "10008646"
      // ) {
      //   this.$router.push(item);
      // } else {
      //   this.$message({
      //     type: "warning", // success error warning
      //     message: "该应用正在开发中",
      //     duration: 2000,
      //   });
      // }
    },
    // 跳转活动室
    toActivityRoom() {
      if (this.redirect) {
        this.$router.push("reservation");
      } else {
        this.$router.push("mobReservation");
      }
    },
    //跳转
    toUrl(item) {
      if (item) {
        this.$router.push(item);
      } else {
        this.$message({
          type: "warning", // success error warning
          message: "该应用正在开发中",
          duration: 2000,
        });
      }
    },
    //跳转详情
    toLogistics(item) {
      this.$router.push({
        path: "/logistics/logisticsDetail",
        query: {
          id: item.id,
        },
      });
    },
    //跳转后台
    toBackend() {
      this.$router.push("/logistics/backend");
    },
    //点击下拉菜单
    clickDrop(index) {
      this.page = 1;
      const ids = this.dropdownItems[index].value;
      console.log(ids, "ids");
      console.log(this.dropdownItems[index], "this.dropdownItems[index]");

      this.menuId = ids;
      this.tabIndex = index;
      this.getList();
    },
    //选择下拉菜单
    changeDrop(val, e) {
      console.log(val, "valvalvalval");
      console.log(e, "eeeeeee");

      const find = val.options.find((item) => item.value == e);
      console.log(find,'find');
      this.tagList = [find];
      this.menuId = e;
      this.page = 1;
      // 清空其他下拉菜单的选中状态
      this.dropdownItems.forEach((item, i) => {
        if (this.tabIndex != i) {
          item.value = null; // 取消其他菜单的选中值
        }
      });
      this.getMenuList();
    },
    // 删除标签
    handleClose(){
      this.tagList = []
      this.menuId = this.dropdownItems[0]?.value
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    background: #f7f9fa;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding-top: 40px;
  .search {
    background: #fff;
    border-radius: 40px;
    padding: 0 0 0 20px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    img {
      width: 55px;
      height: 55px;
      margin-right: 32px;
    }
    .my_img {
      border-radius: 50%;
    }
    ::v-deep {
      .el-input {
        height: 100%;
      }
      .el-input__inner {
        height: 100%;
        background: #fff;
        border: none;
        font-size: 32px;
        color: rgba(125, 133, 146, 1);
      }
    }
  }
  .bar {
    width: 100%;
    background: #fff;
    border-radius: 30px;
    // height: 340px;
    // height: 180px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 25px;
    margin-top: 40px;
    img {
      width: 48%;
      height: 130px;
      margin-bottom: 20px;
    }
    img:last-child,img:nth-last-child(2){
      margin-bottom: 0px;
    }
  }
  .tab {
    ::v-deep {
      //   .van-dropdown-menu__title--active {
      //     color: #000;
      //     position: relative;
      //   }
      .active {
        color: #000;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 35px;
          height: 5px;
          // background: rgba(78, 162, 124, 1);
          position: absolute;
          border-radius: 10px;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .van-dropdown-menu__item{
        align-items: flex-end;
      }
      .van-dropdown-menu__bar {
        background: none !important;
        box-shadow: none !important;
        height: 80px;
      }
      .van-dropdown-menu__title::after {
        border-color: transparent transparent #000 #000;
      }
    }
  }
  .tag{
    padding-left: 30px;
    margin-bottom: 30px;
    ::v-deep {
      .el-tag--mini{
        width: 140px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  .list {
    width: 90%;
    // height: calc(100vh - 540px);
    height: calc(100vh - 750px);
    margin: auto;
    overflow: auto;
    // 隐藏滚动条
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    // position: relative;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    ::v-deep {
      .el-loading-spinner {
        margin-top: 200px;
        top: 0;
      }
    }
    .list_item {
      background: #fff;
      border-radius: 40px;
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // height: 240px;
      margin-bottom: 30px;
      .left {
        width: 36.5%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          // border-radius: 20px;
        }
      }
      .right {
        width: 70%;
        height: 100%;
        padding-left: 30px;
        .title {
          font-weight: bold;
          font-size: 30px;
        }
        .con {
          ::v-deep {
            .article__title,
            .article__time,
            .original-sign {
              font-size: 25px !important;
            }
          }
          color: rgba(102, 102, 102, 1);
          margin: 10px 0;
          display: -webkit-box; /* 需要组合使用 */
          -webkit-box-orient: vertical; /* 设置为垂直方向 */
          -webkit-line-clamp: 2; /* 显示两行 */
          overflow: hidden; /* 隐藏多余的文本 */
          text-overflow: ellipsis; /* 溢出时显示省略号 */
        }
        .rightBot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-top: 30px;
          .type {
            color: rgba(78, 162, 124, 1);
            background: rgba(78, 162, 124, 0.1);
            padding: 10px 20px;
            border-radius: 20px;
            font-size: 25px;
          }
          .time {
            font-size: 25px;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
  }
}
</style>
